<template>
  <div class="mainSection">
    <div class="container">
      <StructureCompany />
    </div>
  </div>
</template>

<script>
// import Interface from 'components/setting/interface/Interface'
import StructureCompany from 'components/setting/structureCompany/StructureCompany'
export default {
  name: 'settingStructureCompany',
  components: { StructureCompany },
}
</script>
